import { render, staticRenderFns } from "./ecndep.vue?vue&type=template&id=31bc384a&scoped=true&"
import script from "./ecndep.vue?vue&type=script&lang=js&"
export * from "./ecndep.vue?vue&type=script&lang=js&"
import style0 from "./ecndep.vue?vue&type=style&index=0&id=31bc384a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc384a",
  null
  
)

export default component.exports